var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "@irati/utils/lang";
import MenuLink from "./MenuLink";
var AccountSideBarLogout = function (props, _a) {
    var apps = _a.apps;
    return (React.createElement(MenuLink, __assign({}, props, { to: "/", app: apps.ACCOUNT }),
        React.createElement(FormattedMessage, { id: "account.sidebar.link" })));
};
AccountSideBarLogout.contextTypes = {
    apps: PropTypes.object.isRequired
};
export default AccountSideBarLogout;
